<template>
	<v-card :loading="loading" height="500"  style="overflow-y: auto">
		<Modal v-if="showModal" @close="showModal = false">
			<h3 slot="header">custom header</h3>
		</modal>
		<v-card-title class="justify-center">{{titulo}}</v-card-title>
		<v-card-text>
			<v-row>
				<v-col v-for="registro in registros" :key="registro.id" cols="12" class="col-sm-6">
					<v-hover v-slot:default="{hover}">
					<v-card class="mx-auto" :elevation="hover ? 16 : 2">
						<v-card-title v-if="registro.titulo.lenght <= 35" class=" py-2 primary white--text">{{registro.titulo}}</v-card-title>
						<v-card-title v-else  class=" py-2 primary white--text">{{registro.titulo.substring(0,35) + '...'}}</v-card-title>
						<v-card-text class="pt-4 pb-0">
							<p>Publicado em: {{registro.data_publicacao}}<br />
							Publicado por: {{registro.iniciado}}<br />
							Autor: {{registro.autor}}<br />
							Grau: {{registro.grau}}<br />
							Leitura: {{registro.status_leitura}}</p>
						</v-card-text>
						<v-card-actions class="blue-grey lighten-5">
							<v-btn @click="abreTexto(registro)" text color="primary">Ler texto...</v-btn>
						</v-card-actions>
					</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
	import Modal from '@/components/geral/Modal'
	import { baseApiUrl, showError } from "@/config/global"
	import axios from 'axios'
	import {mapState} from 'vuex'

	export default{
		name: 'UltimosRegistros',
		props: ['titulo'],
		computed:{
			... mapState(['user']),
		},
		components: {Modal},
		data(){
			return{
				showModal: false,
				buscandoTextos: true,
				itens: [],
				registros: {},
				loading: false,
			}
		},
		methods:{
			abreTexto(registro){
				this.$emit('abrirTexto', registro)
			},

			buscaTextos(){
				const url = `${baseApiUrl}/home/ultimosTextos.php?grau=${this.user.outros.grauAtual}&iniciado=${this.user.iniciado}`
				this.loading = true
				axios(url)
					.then(res => {
						this.registros = res.data.dados.map(txt => {
							return{
								...txt,
								status_leitura: txt.lido == "1" ? 'realizada' : 'pendente'
							}
						})

						this.loading = false
					})
					.catch(() => {
						showError
						this.loading = false
						})

					
			},
		},

		watch:{
			registros(){
				this.buscandoTextos = !this.buscandoTextos
			},
		},

		created(){
			this.buscaTextos()
		}
	}

</script>

<style scoped>
.titulo{
	text-align: center;
}

.corpo{
	height: calc(70vh - 200px);
}
	div.registros-textos{
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		justify-content: space-between;
		max-height: 80vh;
		height: 70vh;
		width: 90%;
		padding: 20px 10px 10px 10px;
		background-color: rgba(230, 230, 230, 0.2);
		border-radius: 6px;
		box-shadow: 3px 3px 6px rgb(0,0,0,0.5);
		
		overflow-y: auto;
		margin: 0 auto;
	}

	div.registros-textos div.titulo{
		height: 50px;
	}

	.registros-textos h1{
		font-size: 1.8rem;
		text-align: center;
	}


	div.registros-textos div.corpo-itens{
		height: 450px;
		display: flex;
		flex-direction: column;
		
	}

	div.registros-textos div.item-texto{
		font-size: 0.7rem;
		cursor: pointer;
		height: 100px;
		padding: 8px;
		background-color: var(--cor-compl);
		box-shadow: 4px 4px 8px rgba(0,0,0,0.1);
		margin-top: 4px;
	}

	div.registros-textos div.item-texto:hover{
		background-color: rgba(0,0,0,0.1);
	}

	.item-texto h2{
		font-size: 1.1rem;
		padding-left: 8px;
	}

	.item-texto .dados{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
</style>